import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import * as CryptoJS from 'crypto-js';
import { Globals } from '.././globals';

@Injectable()
export class ToppersService {
  user: any;
  reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
  constructor(private http: HttpClient, private _global: Globals) {

  }
  readonly rootUrl = this._global.siteUrl;

  addToppersDetail(Obj) {

    // const body = {
    //  Obj:Obj,
    //   userId:Obj.userId,
    //  }  
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'toppers/addtoppersdetail', Obj);
  }

  updateToppersdetail(Obj, id) {

    const body = {
      Obj: Obj,
      id: id,
    }
    return this.http.post(this.rootUrl + 'toppers/updatetoppersdetail', body);
  }

  getTopperDetailsById(userId) {
    const body = { userId: userId, }
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'toppers/gettoppersdetailbyid', body, { headers: reqHeader });
  }

  getTopperLIsting(start, end, catId) {
    const body = {
      start: start, end: end, catId: catId
    }
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'toppers/gettopperslist', body, { headers: reqHeader });
  }
  getTopperLIstingAdmin(obj) {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + 'toppers/gettopperslistadmin', obj, { headers: reqHeader });
  }


  addToppersCat(Obj) {
    return this.http.post(this.rootUrl + 'toppers/addtopperscat', Obj);
  }
  getTopperCatLIsting(start, end, status) {
    const body = {
      start: start, end: end, isActive:status
    }
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    return this.http.post(this.rootUrl + "toppers/gettopperscategory", body, { headers: reqHeader });
  }

  editCategoryById(id) {
    console.log('inside service');
    const body = { id: id }
    return this.http.post(this.rootUrl + 'toppers/gettopperscatbyid', body);
  }

  updateCategory(Obj, id) {
    const body = {
      Obj: Obj,
      id: id,
    }
    return this.http.post(this.rootUrl + 'toppers/updatecategorydetail', body);
  }

  changestatustoppers(Obj) {
    return this.http.post(this.rootUrl + 'toppers/changestatustoppers', Obj);
  }

  //del advertisement
  streamlist() {
    var reqHeader = new HttpHeaders({ 'No-Auth': 'True' });
    //return this.http.post(this.rootUrl + 'session/getstreamtypelist', sId,{ headers: reqHeader});
    return this.http.get(this.rootUrl + 'session/getstreamtypelist', { headers: reqHeader });
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/service/toppers.service.ts